import {Lang} from 'contexts/LangContext';

export enum SearchItemType {
    Main = 'main',
    Documentation = 'doc',
    Blog = 'blog',
    Services = 'services',
    Partners = 'partners',
    Solutions = 'solutions',
    Features = 'features',
    Events = 'events',
    Cases = 'cases',
    Marketplace = 'marketplace',
}

export interface SearchMapItem {
    type: SearchItemType;
    count: number;
}

export interface BreadcrumbItem {
    name: string;
    href?: string;
}

export interface SearchMeta {
    stage?: string;
    date?: Date;
    author?: string;
    address?: string;
    keywords?: string[];
}

export interface SearchExtra {
    content: string;
}

export interface SearchHighlights {
    title: string;
    content: string;
    description: string;
}

export interface SearchItem {
    id: string;
    name: string;
    isStatic: boolean;
    url: string;
    title: string;
    lang: Lang;
    type: SearchItemType;
    typeUrl: string;
    subType?: string;
    subTypeUrl?: string;
    description?: string;
    icon?: string;
    pagerank: number;
    breadcrumbs?: BreadcrumbItem[];
    highlights?: SearchHighlights;
    meta?: SearchMeta;
    extra?: SearchExtra[];
}

export interface SearchResult {
    map: SearchMapItem[];
    hits: SearchItem[];
    total: number;
    found: boolean;
}
